export var cmap = {
  '78-EUC-H': function EUCH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-78-EUC-H" */'./78-EUC-H');
  },
  '78-EUC-V': function EUCV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-78-EUC-V" */'./78-EUC-V');
  },
  '78-H': function H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-78-H" */'./78-H');
  },
  '78-RKSJ-H': function RKSJH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-78-RKSJ-H" */'./78-RKSJ-H');
  },
  '78-RKSJ-V': function RKSJV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-78-RKSJ-V" */'./78-RKSJ-V');
  },
  '78-V': function V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-78-V" */'./78-V');
  },
  '78ms-RKSJ-H': function msRKSJH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-78ms-RKSJ-H" */'./78ms-RKSJ-H');
  },
  '78ms-RKSJ-V': function msRKSJV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-78ms-RKSJ-V" */'./78ms-RKSJ-V');
  },
  '83pv-RKSJ-H': function pvRKSJH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-83pv-RKSJ-H" */'./83pv-RKSJ-H');
  },
  '90ms-RKSJ-H': function msRKSJH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-90ms-RKSJ-H" */'./90ms-RKSJ-H');
  },
  '90ms-RKSJ-V': function msRKSJV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-90ms-RKSJ-V" */'./90ms-RKSJ-V');
  },
  '90msp-RKSJ-H': function mspRKSJH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-90msp-RKSJ-H" */'./90msp-RKSJ-H');
  },
  '90msp-RKSJ-V': function mspRKSJV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-90msp-RKSJ-V" */'./90msp-RKSJ-V');
  },
  '90pv-RKSJ-H': function pvRKSJH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-90pv-RKSJ-H" */'./90pv-RKSJ-H');
  },
  '90pv-RKSJ-V': function pvRKSJV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-90pv-RKSJ-V" */'./90pv-RKSJ-V');
  },
  'Add-H': function AddH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Add-H" */'./Add-H');
  },
  'Add-RKSJ-H': function AddRKSJH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Add-RKSJ-H" */'./Add-RKSJ-H');
  },
  'Add-RKSJ-V': function AddRKSJV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Add-RKSJ-V" */'./Add-RKSJ-V');
  },
  'Add-V': function AddV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Add-V" */'./Add-V');
  },
  'Adobe-CNS1-0': function AdobeCNS10() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-CNS1-0" */'./Adobe-CNS1-0');
  },
  'Adobe-CNS1-1': function AdobeCNS11() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-CNS1-1" */'./Adobe-CNS1-1');
  },
  'Adobe-CNS1-2': function AdobeCNS12() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-CNS1-2" */'./Adobe-CNS1-2');
  },
  'Adobe-CNS1-3': function AdobeCNS13() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-CNS1-3" */'./Adobe-CNS1-3');
  },
  'Adobe-CNS1-4': function AdobeCNS14() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-CNS1-4" */'./Adobe-CNS1-4');
  },
  'Adobe-CNS1-5': function AdobeCNS15() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-CNS1-5" */'./Adobe-CNS1-5');
  },
  'Adobe-CNS1-6': function AdobeCNS16() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-CNS1-6" */'./Adobe-CNS1-6');
  },
  'Adobe-CNS1-UCS2': function AdobeCNS1UCS2() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-CNS1-UCS2" */'./Adobe-CNS1-UCS2');
  },
  'Adobe-GB1-0': function AdobeGB10() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-GB1-0" */'./Adobe-GB1-0');
  },
  'Adobe-GB1-1': function AdobeGB11() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-GB1-1" */'./Adobe-GB1-1');
  },
  'Adobe-GB1-2': function AdobeGB12() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-GB1-2" */'./Adobe-GB1-2');
  },
  'Adobe-GB1-3': function AdobeGB13() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-GB1-3" */'./Adobe-GB1-3');
  },
  'Adobe-GB1-4': function AdobeGB14() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-GB1-4" */'./Adobe-GB1-4');
  },
  'Adobe-GB1-5': function AdobeGB15() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-GB1-5" */'./Adobe-GB1-5');
  },
  'Adobe-GB1-UCS2': function AdobeGB1UCS2() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-GB1-UCS2" */'./Adobe-GB1-UCS2');
  },
  'Adobe-Japan1-0': function AdobeJapan10() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-Japan1-0" */'./Adobe-Japan1-0');
  },
  'Adobe-Japan1-1': function AdobeJapan11() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-Japan1-1" */'./Adobe-Japan1-1');
  },
  'Adobe-Japan1-2': function AdobeJapan12() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-Japan1-2" */'./Adobe-Japan1-2');
  },
  'Adobe-Japan1-3': function AdobeJapan13() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-Japan1-3" */'./Adobe-Japan1-3');
  },
  'Adobe-Japan1-4': function AdobeJapan14() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-Japan1-4" */'./Adobe-Japan1-4');
  },
  'Adobe-Japan1-5': function AdobeJapan15() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-Japan1-5" */'./Adobe-Japan1-5');
  },
  'Adobe-Japan1-6': function AdobeJapan16() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-Japan1-6" */'./Adobe-Japan1-6');
  },
  'Adobe-Japan1-UCS2': function AdobeJapan1UCS2() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-Japan1-UCS2" */'./Adobe-Japan1-UCS2');
  },
  'Adobe-Korea1-0': function AdobeKorea10() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-Korea1-0" */'./Adobe-Korea1-0');
  },
  'Adobe-Korea1-1': function AdobeKorea11() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-Korea1-1" */'./Adobe-Korea1-1');
  },
  'Adobe-Korea1-2': function AdobeKorea12() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-Korea1-2" */'./Adobe-Korea1-2');
  },
  'Adobe-Korea1-UCS2': function AdobeKorea1UCS2() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Adobe-Korea1-UCS2" */'./Adobe-Korea1-UCS2');
  },
  'B5-H': function B5H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-B5-H" */'./B5-H');
  },
  'B5-V': function B5V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-B5-V" */'./B5-V');
  },
  'B5pc-H': function B5pcH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-B5pc-H" */'./B5pc-H');
  },
  'B5pc-V': function B5pcV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-B5pc-V" */'./B5pc-V');
  },
  'CNS-EUC-H': function CNSEUCH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-CNS-EUC-H" */'./CNS-EUC-H');
  },
  'CNS-EUC-V': function CNSEUCV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-CNS-EUC-V" */'./CNS-EUC-V');
  },
  'CNS1-H': function CNS1H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-CNS1-H" */'./CNS1-H');
  },
  'CNS1-V': function CNS1V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-CNS1-V" */'./CNS1-V');
  },
  'CNS2-H': function CNS2H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-CNS2-H" */'./CNS2-H');
  },
  'CNS2-V': function CNS2V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-CNS2-V" */'./CNS2-V');
  },
  'ETHK-B5-H': function ETHKB5H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-ETHK-B5-H" */'./ETHK-B5-H');
  },
  'ETHK-B5-V': function ETHKB5V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-ETHK-B5-V" */'./ETHK-B5-V');
  },
  'ETen-B5-H': function ETenB5H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-ETen-B5-H" */'./ETen-B5-H');
  },
  'ETen-B5-V': function ETenB5V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-ETen-B5-V" */'./ETen-B5-V');
  },
  'ETenms-B5-H': function ETenmsB5H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-ETenms-B5-H" */'./ETenms-B5-H');
  },
  'ETenms-B5-V': function ETenmsB5V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-ETenms-B5-V" */'./ETenms-B5-V');
  },
  'EUC-H': function EUCH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-EUC-H" */'./EUC-H');
  },
  'EUC-V': function EUCV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-EUC-V" */'./EUC-V');
  },
  'Ext-H': function ExtH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Ext-H" */'./Ext-H');
  },
  'Ext-RKSJ-H': function ExtRKSJH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Ext-RKSJ-H" */'./Ext-RKSJ-H');
  },
  'Ext-RKSJ-V': function ExtRKSJV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Ext-RKSJ-V" */'./Ext-RKSJ-V');
  },
  'Ext-V': function ExtV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Ext-V" */'./Ext-V');
  },
  'GB-EUC-H': function GBEUCH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-GB-EUC-H" */'./GB-EUC-H');
  },
  'GB-EUC-V': function GBEUCV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-GB-EUC-V" */'./GB-EUC-V');
  },
  'GB-H': function GBH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-GB-H" */'./GB-H');
  },
  'GB-V': function GBV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-GB-V" */'./GB-V');
  },
  'GBK-EUC-H': function GBKEUCH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-GBK-EUC-H" */'./GBK-EUC-H');
  },
  'GBK-EUC-V': function GBKEUCV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-GBK-EUC-V" */'./GBK-EUC-V');
  },
  'GBK2K-H': function GBK2KH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-GBK2K-H" */'./GBK2K-H');
  },
  'GBK2K-V': function GBK2KV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-GBK2K-V" */'./GBK2K-V');
  },
  'GBKp-EUC-H': function GBKpEUCH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-GBKp-EUC-H" */'./GBKp-EUC-H');
  },
  'GBKp-EUC-V': function GBKpEUCV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-GBKp-EUC-V" */'./GBKp-EUC-V');
  },
  'GBT-EUC-H': function GBTEUCH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-GBT-EUC-H" */'./GBT-EUC-H');
  },
  'GBT-EUC-V': function GBTEUCV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-GBT-EUC-V" */'./GBT-EUC-V');
  },
  'GBT-H': function GBTH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-GBT-H" */'./GBT-H');
  },
  'GBT-V': function GBTV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-GBT-V" */'./GBT-V');
  },
  'GBTpc-EUC-H': function GBTpcEUCH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-GBTpc-EUC-H" */'./GBTpc-EUC-H');
  },
  'GBTpc-EUC-V': function GBTpcEUCV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-GBTpc-EUC-V" */'./GBTpc-EUC-V');
  },
  'GBpc-EUC-H': function GBpcEUCH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-GBpc-EUC-H" */'./GBpc-EUC-H');
  },
  'GBpc-EUC-V': function GBpcEUCV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-GBpc-EUC-V" */'./GBpc-EUC-V');
  },
  H: function H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-H" */'./H');
  },
  'HKdla-B5-H': function HKdlaB5H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-HKdla-B5-H" */'./HKdla-B5-H');
  },
  'HKdla-B5-V': function HKdlaB5V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-HKdla-B5-V" */'./HKdla-B5-V');
  },
  'HKdlb-B5-H': function HKdlbB5H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-HKdlb-B5-H" */'./HKdlb-B5-H');
  },
  'HKdlb-B5-V': function HKdlbB5V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-HKdlb-B5-V" */'./HKdlb-B5-V');
  },
  'HKgccs-B5-H': function HKgccsB5H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-HKgccs-B5-H" */'./HKgccs-B5-H');
  },
  'HKgccs-B5-V': function HKgccsB5V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-HKgccs-B5-V" */'./HKgccs-B5-V');
  },
  'HKm314-B5-H': function HKm314B5H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-HKm314-B5-H" */'./HKm314-B5-H');
  },
  'HKm314-B5-V': function HKm314B5V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-HKm314-B5-V" */'./HKm314-B5-V');
  },
  'HKm471-B5-H': function HKm471B5H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-HKm471-B5-H" */'./HKm471-B5-H');
  },
  'HKm471-B5-V': function HKm471B5V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-HKm471-B5-V" */'./HKm471-B5-V');
  },
  'HKscs-B5-H': function HKscsB5H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-HKscs-B5-H" */'./HKscs-B5-H');
  },
  'HKscs-B5-V': function HKscsB5V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-HKscs-B5-V" */'./HKscs-B5-V');
  },
  Hankaku: function Hankaku() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Hankaku" */'./Hankaku');
  },
  Hiragana: function Hiragana() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Hiragana" */'./Hiragana');
  },
  'KSC-EUC-H': function KSCEUCH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-KSC-EUC-H" */'./KSC-EUC-H');
  },
  'KSC-EUC-V': function KSCEUCV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-KSC-EUC-V" */'./KSC-EUC-V');
  },
  'KSC-H': function KSCH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-KSC-H" */'./KSC-H');
  },
  'KSC-Johab-H': function KSCJohabH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-KSC-Johab-H" */'./KSC-Johab-H');
  },
  'KSC-Johab-V': function KSCJohabV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-KSC-Johab-V" */'./KSC-Johab-V');
  },
  'KSC-V': function KSCV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-KSC-V" */'./KSC-V');
  },
  'KSCms-UHC-H': function KSCmsUHCH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-KSCms-UHC-H" */'./KSCms-UHC-H');
  },
  'KSCms-UHC-HW-H': function KSCmsUHCHWH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-KSCms-UHC-HW-H" */'./KSCms-UHC-HW-H');
  },
  'KSCms-UHC-HW-V': function KSCmsUHCHWV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-KSCms-UHC-HW-V" */'./KSCms-UHC-HW-V');
  },
  'KSCms-UHC-V': function KSCmsUHCV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-KSCms-UHC-V" */'./KSCms-UHC-V');
  },
  'KSCpc-EUC-H': function KSCpcEUCH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-KSCpc-EUC-H" */'./KSCpc-EUC-H');
  },
  'KSCpc-EUC-V': function KSCpcEUCV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-KSCpc-EUC-V" */'./KSCpc-EUC-V');
  },
  Katakana: function Katakana() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Katakana" */'./Katakana');
  },
  'NWP-H': function NWPH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-NWP-H" */'./NWP-H');
  },
  'NWP-V': function NWPV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-NWP-V" */'./NWP-V');
  },
  'RKSJ-H': function RKSJH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-RKSJ-H" */'./RKSJ-H');
  },
  'RKSJ-V': function RKSJV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-RKSJ-V" */'./RKSJ-V');
  },
  Roman: function Roman() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-Roman" */'./Roman');
  },
  'UniCNS-UCS2-H': function UniCNSUCS2H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniCNS-UCS2-H" */'./UniCNS-UCS2-H');
  },
  'UniCNS-UCS2-V': function UniCNSUCS2V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniCNS-UCS2-V" */'./UniCNS-UCS2-V');
  },
  'UniCNS-UTF16-H': function UniCNSUTF16H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniCNS-UTF16-H" */'./UniCNS-UTF16-H');
  },
  'UniCNS-UTF16-V': function UniCNSUTF16V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniCNS-UTF16-V" */'./UniCNS-UTF16-V');
  },
  'UniCNS-UTF32-H': function UniCNSUTF32H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniCNS-UTF32-H" */'./UniCNS-UTF32-H');
  },
  'UniCNS-UTF32-V': function UniCNSUTF32V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniCNS-UTF32-V" */'./UniCNS-UTF32-V');
  },
  'UniCNS-UTF8-H': function UniCNSUTF8H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniCNS-UTF8-H" */'./UniCNS-UTF8-H');
  },
  'UniCNS-UTF8-V': function UniCNSUTF8V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniCNS-UTF8-V" */'./UniCNS-UTF8-V');
  },
  'UniGB-UCS2-H': function UniGBUCS2H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniGB-UCS2-H" */'./UniGB-UCS2-H');
  },
  'UniGB-UCS2-V': function UniGBUCS2V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniGB-UCS2-V" */'./UniGB-UCS2-V');
  },
  'UniGB-UTF16-H': function UniGBUTF16H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniGB-UTF16-H" */'./UniGB-UTF16-H');
  },
  'UniGB-UTF16-V': function UniGBUTF16V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniGB-UTF16-V" */'./UniGB-UTF16-V');
  },
  'UniGB-UTF32-H': function UniGBUTF32H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniGB-UTF32-H" */'./UniGB-UTF32-H');
  },
  'UniGB-UTF32-V': function UniGBUTF32V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniGB-UTF32-V" */'./UniGB-UTF32-V');
  },
  'UniGB-UTF8-H': function UniGBUTF8H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniGB-UTF8-H" */'./UniGB-UTF8-H');
  },
  'UniGB-UTF8-V': function UniGBUTF8V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniGB-UTF8-V" */'./UniGB-UTF8-V');
  },
  'UniJIS-UCS2-H': function UniJISUCS2H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniJIS-UCS2-H" */'./UniJIS-UCS2-H');
  },
  'UniJIS-UCS2-HW-H': function UniJISUCS2HWH() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniJIS-UCS2-HW-H" */'./UniJIS-UCS2-HW-H');
  },
  'UniJIS-UCS2-HW-V': function UniJISUCS2HWV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniJIS-UCS2-HW-V" */'./UniJIS-UCS2-HW-V');
  },
  'UniJIS-UCS2-V': function UniJISUCS2V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniJIS-UCS2-V" */'./UniJIS-UCS2-V');
  },
  'UniJIS-UTF16-H': function UniJISUTF16H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniJIS-UTF16-H" */'./UniJIS-UTF16-H');
  },
  'UniJIS-UTF16-V': function UniJISUTF16V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniJIS-UTF16-V" */'./UniJIS-UTF16-V');
  },
  'UniJIS-UTF32-H': function UniJISUTF32H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniJIS-UTF32-H" */'./UniJIS-UTF32-H');
  },
  'UniJIS-UTF32-V': function UniJISUTF32V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniJIS-UTF32-V" */'./UniJIS-UTF32-V');
  },
  'UniJIS-UTF8-H': function UniJISUTF8H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniJIS-UTF8-H" */'./UniJIS-UTF8-H');
  },
  'UniJIS-UTF8-V': function UniJISUTF8V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniJIS-UTF8-V" */'./UniJIS-UTF8-V');
  },
  'UniJIS2004-UTF16-H': function UniJIS2004UTF16H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniJIS2004-UTF16-H" */'./UniJIS2004-UTF16-H');
  },
  'UniJIS2004-UTF16-V': function UniJIS2004UTF16V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniJIS2004-UTF16-V" */'./UniJIS2004-UTF16-V');
  },
  'UniJIS2004-UTF32-H': function UniJIS2004UTF32H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniJIS2004-UTF32-H" */'./UniJIS2004-UTF32-H');
  },
  'UniJIS2004-UTF32-V': function UniJIS2004UTF32V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniJIS2004-UTF32-V" */'./UniJIS2004-UTF32-V');
  },
  'UniJIS2004-UTF8-H': function UniJIS2004UTF8H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniJIS2004-UTF8-H" */'./UniJIS2004-UTF8-H');
  },
  'UniJIS2004-UTF8-V': function UniJIS2004UTF8V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniJIS2004-UTF8-V" */'./UniJIS2004-UTF8-V');
  },
  'UniJISPro-UCS2-HW-V': function UniJISProUCS2HWV() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniJISPro-UCS2-HW-V" */'./UniJISPro-UCS2-HW-V');
  },
  'UniJISPro-UCS2-V': function UniJISProUCS2V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniJISPro-UCS2-V" */'./UniJISPro-UCS2-V');
  },
  'UniJISPro-UTF8-V': function UniJISProUTF8V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniJISPro-UTF8-V" */'./UniJISPro-UTF8-V');
  },
  'UniJISX0213-UTF32-H': function UniJISX0213UTF32H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniJISX0213-UTF32-H" */'./UniJISX0213-UTF32-H');
  },
  'UniJISX0213-UTF32-V': function UniJISX0213UTF32V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniJISX0213-UTF32-V" */'./UniJISX0213-UTF32-V');
  },
  'UniJISX02132004-UTF32-H': function UniJISX02132004UTF32H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniJISX02132004-UTF32-H" */'./UniJISX02132004-UTF32-H');
  },
  'UniJISX02132004-UTF32-V': function UniJISX02132004UTF32V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniJISX02132004-UTF32-V" */'./UniJISX02132004-UTF32-V');
  },
  'UniKS-UCS2-H': function UniKSUCS2H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniKS-UCS2-H" */'./UniKS-UCS2-H');
  },
  'UniKS-UCS2-V': function UniKSUCS2V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniKS-UCS2-V" */'./UniKS-UCS2-V');
  },
  'UniKS-UTF16-H': function UniKSUTF16H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniKS-UTF16-H" */'./UniKS-UTF16-H');
  },
  'UniKS-UTF16-V': function UniKSUTF16V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniKS-UTF16-V" */'./UniKS-UTF16-V');
  },
  'UniKS-UTF32-H': function UniKSUTF32H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniKS-UTF32-H" */'./UniKS-UTF32-H');
  },
  'UniKS-UTF32-V': function UniKSUTF32V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniKS-UTF32-V" */'./UniKS-UTF32-V');
  },
  'UniKS-UTF8-H': function UniKSUTF8H() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniKS-UTF8-H" */'./UniKS-UTF8-H');
  },
  'UniKS-UTF8-V': function UniKSUTF8V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-UniKS-UTF8-V" */'./UniKS-UTF8-V');
  },
  V: function V() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-V" */'./V');
  },
  'WP-Symbol': function WPSymbol() {
    return import( /* webpackChunkName: "@atlaskit-internal_media-cname-WP-Symbol" */'./WP-Symbol');
  }
};